import { mapCandidateResponse } from './helpers'

const mutations = {
  candidateDetails: (state, value) => {
    const candidate = mapCandidateResponse(value.length > 0 ? value[0] : {})
    state.candidateDetails = candidate
  },
  candidateDossierDetails: (state, value) => {
    const candidate = mapCandidateResponse(value.candidate[0])
    state.candidateDossierDetails = { ...value, candidate }
  },
  closeupDetails: (state, value) => {
    const details =
      value.length > 0 && value[0].CandidateCloseUp && value[0].CandidateCloseUp.length > 0
        ? value[0].CandidateCloseUp[0]
        : {}
    state.closeupDetails = { ...details, closeUpEnrollType: value[0].closeUpEnrollType }
  },
  closeupCount: (state, value) => {
    state.closeupCount = value[0].closeUpView
  },
  isCloseup: (state, value) => {
    state.isCloseup = value
  },
  candidateInfo: (state, value) => {
    state.candidateInfo = value
  },
}

export default mutations
